// src/pages/Dashboard/Admin/AdherentPret/components/PretDataTable.jsx

import React from "react";
import { FaEdit, FaTrash } from "react-icons/fa";

import {
  formatDateShort,
  getArticlePhotoSrc,
  getPretAdherentName,
  getPretArticleName,
  getPretStatus,
  getPretStatusClass,
  getPretStatusLabel,
} from "../utils/adherentPretDashboardUtils";

export default function PretDataTable({
  prets = [],
  onEdit,
  onDelete,
  deletingId,
}) {
  return (
    <div className="hidden md:block">
      <div className="overflow-x-auto rounded-2xl border border-slate-200 bg-white dark:border-slate-800 dark:bg-slate-900/60">
        <table className="min-w-[1050px] w-full">
          <thead className="sticky top-0 z-20">
            <tr className="bg-slate-50 text-xs uppercase tracking-wide text-slate-600 dark:bg-slate-900 dark:text-slate-300">
              <th className="px-4 py-3 text-left font-bold">Adhérent</th>
              <th className="px-4 py-3 text-left font-bold">Matériel</th>
              <th className="px-4 py-3 text-left font-bold">Date prêt</th>
              <th className="px-4 py-3 text-left font-bold">Date remise</th>
              <th className="px-4 py-3 text-left font-bold">Statut</th>
              <th className="px-4 py-3 text-left font-bold">Note</th>
              <th className="sticky right-0 z-30 w-32 bg-slate-50 px-4 py-3 text-right font-bold dark:bg-slate-900">
                Actions
              </th>
            </tr>
          </thead>

          <tbody className="divide-y divide-slate-100 text-sm dark:divide-slate-800">
            {prets.map((pret) => {
              const status = getPretStatus(pret);

              return (
                <tr
                  key={pret.id}
                  className="transition hover:bg-slate-50/80 dark:hover:bg-slate-800/40"
                >
                  <td className="px-4 py-3">
                    <div className="font-bold text-slate-900 dark:text-white">
                      {getPretAdherentName(pret) || "—"}
                    </div>
                  </td>

                  <td className="px-4 py-3">
                    <div className="flex items-center gap-3">
                      <img
                        src={getArticlePhotoSrc(pret?.article?.photo_url)}
                        alt={getPretArticleName(pret)}
                        className="h-12 w-12 rounded-2xl object-cover ring-1 ring-slate-200 dark:ring-slate-700"
                        onError={(event) => {
                          event.currentTarget.src = "/img/no-image.jpg";
                        }}
                      />

                      <div>
                        <div className="font-bold text-slate-900 dark:text-white">
                          {getPretArticleName(pret)}
                        </div>

                        <div className="text-xs text-slate-500 dark:text-slate-400">
                          {pret?.article?.categorie || "—"}
                        </div>
                      </div>
                    </div>
                  </td>

                  <td className="px-4 py-3 text-slate-700 dark:text-slate-300">
                    {formatDateShort(pret?.date_pret)}
                  </td>

                  <td className="px-4 py-3 text-slate-700 dark:text-slate-300">
                    {formatDateShort(pret?.date_remise)}
                  </td>

                  <td className="px-4 py-3">
                    <span
                      className={`inline-flex rounded-full px-2.5 py-1 text-xs font-bold ring-1 ${getPretStatusClass(
                        status
                      )}`}
                    >
                      {getPretStatusLabel(status)}
                    </span>
                  </td>

                  <td className="px-4 py-3">
                    <p className="max-w-[360px] text-sm leading-6 text-slate-600 dark:text-slate-300">
                      {pret?.note_pret || "—"}
                    </p>
                  </td>

                  <td className="sticky right-0 z-10 bg-white px-4 py-3 dark:bg-slate-900">
                    <div className="flex items-center justify-end gap-2">
                      <button
                        type="button"
                        onClick={() => onEdit(pret)}
                        className="inline-flex h-9 w-9 items-center justify-center rounded-xl border border-slate-200 bg-white text-slate-700 transition hover:bg-slate-50 hover:text-indigo-700 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-200 dark:hover:bg-slate-700"
                        title="Modifier"
                      >
                        <FaEdit />
                      </button>

                      <button
                        type="button"
                        onClick={() => onDelete(pret)}
                        disabled={deletingId === pret.id}
                        className="inline-flex h-9 w-9 items-center justify-center rounded-xl border border-rose-200 bg-rose-50 text-rose-700 transition hover:bg-rose-100 disabled:opacity-50 dark:border-rose-500/20 dark:bg-rose-500/10 dark:text-rose-300"
                        title="Supprimer"
                      >
                        <FaTrash />
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}